import React, {
  useState,
} from "react";

import {
  PUBLIC_OFFER_STATUS,
} from "../constants/publicOffer.constants";


const PublicOfferActions = ({
  publicOffer,
  accepting,
  acceptOffer,
  onAccepted,
}) => {

  const [
    confirmed,
    setConfirmed,
  ] = useState(false);


  const status =
    publicOffer?.publicOffer?.status;


  /*
  |--------------------------------------------------------------------------
  | Already accepted
  |--------------------------------------------------------------------------
  */

  if (
    status ===
    PUBLIC_OFFER_STATUS.ACCEPTED
  ) {
    return (
      <div className="public-offer-actions accepted">

        <div className="public-offer-action-icon">
          ✓
        </div>

        <div>

          <h3>
            Offer Accepted
          </h3>

          <p>
            This offer has already
            been accepted.
          </p>

        </div>

      </div>
    );
  }


  /*
  |--------------------------------------------------------------------------
  | Cannot accept
  |--------------------------------------------------------------------------
  */

  if (
    status ===
      PUBLIC_OFFER_STATUS.EXPIRED ||
    status ===
      PUBLIC_OFFER_STATUS.REVOKED
  ) {
    return null;
  }


  /*
  |--------------------------------------------------------------------------
  | CONFIRMATION
  |--------------------------------------------------------------------------
  */

  const handleAccept =
    async () => {

      if (!confirmed) {
        setConfirmed(true);
        return;
      }

      try {

        const result =
          await acceptOffer();

        if (onAccepted) {
          onAccepted(
            result
          );
        }

      } catch {
        // Hook handles error.
      }
    };


  return (
    <section className="public-offer-actions">

      {!confirmed ? (

        <>
          <div>

            <h3>
              Ready to proceed?
            </h3>

            <p>
              By accepting this offer,
              you confirm that you have
              reviewed the proposal details.
            </p>

          </div>

          <button
            type="button"
            className="public-offer-primary-button"
            onClick={
              handleAccept
            }
            disabled={accepting}
          >
            Accept Offer
          </button>

        </>

      ) : (

        <>

          <div>

            <h3>
              Confirm Offer Acceptance
            </h3>

            <p>
              Please confirm that you
              want to accept this offer.
            </p>

          </div>

          <div className="public-offer-confirm-actions">

            <button
              type="button"
              className="public-offer-secondary-button"
              onClick={() =>
                setConfirmed(false)
              }
              disabled={accepting}
            >
              Cancel
            </button>

            <button
              type="button"
              className="public-offer-primary-button"
              onClick={
                handleAccept
              }
              disabled={accepting}
            >
              {accepting
                ? "Accepting..."
                : "Confirm & Accept"}
            </button>

          </div>

        </>

      )}

    </section>
  );
};


export default PublicOfferActions;